/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} How_Stamps_Work_List1Inputs */

const en_how_stamps_work_list1 = /** @type {(inputs: How_Stamps_Work_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duplicate cakes from cake boxes turn into stamps.`)
};

const ar_how_stamps_work_list1 = /** @type {(inputs: How_Stamps_Work_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تتحول الكعكات المكررة من صناديق الكعك إلى طوابع.`)
};

const de_how_stamps_work_list1 = /** @type {(inputs: How_Stamps_Work_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Doppelte Kuchen aus Kuchenboxen werden in Stempel umgewandelt.`)
};

const es_how_stamps_work_list1 = /** @type {(inputs: How_Stamps_Work_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los pasteles duplicados de las cajas de pasteles se convierten en sellos.`)
};

const fr_how_stamps_work_list1 = /** @type {(inputs: How_Stamps_Work_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les gâteaux en double des boîtes à gâteaux se transforment en timbres.`)
};

const it_how_stamps_work_list1 = /** @type {(inputs: How_Stamps_Work_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le torte doppie delle scatole di torte si trasformano in timbri.`)
};

const ja_how_stamps_work_list1 = /** @type {(inputs: How_Stamps_Work_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ケーキボックスから獲得した重複ケーキはスタンプに変換されます。`)
};

const ko_how_stamps_work_list1 = /** @type {(inputs: How_Stamps_Work_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`케이크 상자에서 나온 중복 케이크는 스탬프로 전환됩니다.`)
};

const pt_br_how_stamps_work_list1 = /** @type {(inputs: How_Stamps_Work_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bolos repetidos das caixas de bolo se transformam em selos.`)
};

const ru_how_stamps_work_list1 = /** @type {(inputs: How_Stamps_Work_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Повторяющиеся торты из коробок с тортом превращаются в штампы.`)
};

const th_how_stamps_work_list1 = /** @type {(inputs: How_Stamps_Work_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เค้กที่ซ้ำจากกล่องเค้กจะเปลี่ยนเป็นแสตมป์`)
};

const tr_how_stamps_work_list1 = /** @type {(inputs: How_Stamps_Work_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasta kutularından çıkan yinelenen pastalar pula dönüşür.`)
};

const zh_cn_how_stamps_work_list1 = /** @type {(inputs: How_Stamps_Work_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`开启蛋糕盒时，若获得重复的蛋糕将会转换为印花。`)
};

const zh_tw_how_stamps_work_list1 = /** @type {(inputs: How_Stamps_Work_List1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開啟蛋糕盒時，若獲得重複的蛋糕將會轉換為印花。`)
};

/**
* | output |
* | --- |
* | "Duplicate cakes from cake boxes turn into stamps." |
*
* @param {How_Stamps_Work_List1Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const how_stamps_work_list1 = /** @type {((inputs?: How_Stamps_Work_List1Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<How_Stamps_Work_List1Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_how_stamps_work_list1(inputs)
	if (locale === "ar") return ar_how_stamps_work_list1(inputs)
	if (locale === "de") return de_how_stamps_work_list1(inputs)
	if (locale === "es") return es_how_stamps_work_list1(inputs)
	if (locale === "fr") return fr_how_stamps_work_list1(inputs)
	if (locale === "it") return it_how_stamps_work_list1(inputs)
	if (locale === "ja") return ja_how_stamps_work_list1(inputs)
	if (locale === "ko") return ko_how_stamps_work_list1(inputs)
	if (locale === "pt_br") return pt_br_how_stamps_work_list1(inputs)
	if (locale === "ru") return ru_how_stamps_work_list1(inputs)
	if (locale === "th") return th_how_stamps_work_list1(inputs)
	if (locale === "tr") return tr_how_stamps_work_list1(inputs)
	if (locale === "zh_cn") return zh_cn_how_stamps_work_list1(inputs)
	return zh_tw_how_stamps_work_list1(inputs)
});